// externals
import { ThemeProvider } from 'styled-components';
import { Route } from 'react-router-dom';

// components
import ChangeVehicleActivity from './ChangeVehicleActivity';

// utils
import { getAllRoutes } from '../utils/routes';

// types
import type { ChangeVehicleActivityProps } from '../types';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

const Root = (props: ChangeVehicleActivityProps) => {
    const theme = useInterstateTheme();
    const { root } = getAllRoutes(props.baseRoute);

    return (
        <ThemeProvider theme={theme}>
            <Route path={root} render={() => <ChangeVehicleActivity {...props} />} />
        </ThemeProvider>
    );
};

Root.displayName = 'ChangeVehicleActivity';

export default Root;
